import { render, staticRenderFns } from "./Segmented.vue?vue&type=template&id=100828ed&"
import script from "./Segmented.vue?vue&type=script&lang=js&"
export * from "./Segmented.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports